import HttpClient from "../http/http_client";
export const getWinningTeamRequest = async () => {
    try {
        const resposne = await HttpClient.get('winner-teams/');
        return {
            success : true,
            data : resposne.data,
        }
    } catch (error) {
        if (error.resposne) {
            const {status, data} = error.resposne;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
}